import React from 'react';
import './Alerts.css';

const Alerts = () => {
  const alerts = [
    { id: 1, type: 'error', title: 'Integration Failed', message: 'Slack integration is not responding', time: '2 minutes ago', status: 'unread' },
    { id: 2, type: 'warning', title: 'High Usage Alert', message: 'Asana API usage is approaching limits', time: '15 minutes ago', status: 'read' },
    { id: 3, type: 'info', title: 'Update Available', message: 'New version of Zoom integration available', time: '1 hour ago', status: 'read' },
    { id: 4, type: 'success', title: 'Integration Restored', message: 'Box integration is back online', time: '2 hours ago', status: 'read' },
  ];

  return (
    <div className="alerts-page">
      <div className="main-title">Alerts</div>
      
      <div className="alerts-content">
        <div className="alerts-header">
          <div className="alerts-stats">
            <span className="stat-item">
              <span className="stat-number">4</span>
              <span className="stat-label">Total Alerts</span>
            </span>
            <span className="stat-item">
              <span className="stat-number">1</span>
              <span className="stat-label">Unread</span>
            </span>
          </div>
          <button className="mark-all-read-btn">Mark All as Read</button>
        </div>
        
        <div className="alerts-list">
          {alerts.map((alert) => (
            <div key={alert.id} className={`alert-item ${alert.type} ${alert.status}`}>
              <div className="alert-icon">
                {alert.type === 'error' && '❌'}
                {alert.type === 'warning' && '⚠️'}
                {alert.type === 'info' && 'ℹ️'}
                {alert.type === 'success' && '✅'}
              </div>
              <div className="alert-content">
                <div className="alert-title">{alert.title}</div>
                <div className="alert-message">{alert.message}</div>
                <div className="alert-time">{alert.time}</div>
              </div>
              <div className="alert-actions">
                <button className="action-btn">Dismiss</button>
                <button className="action-btn">View Details</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Alerts; 